var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.875C14.0875 21.875 13.825 23.625 11.655 23.625C9.5725 23.625 9.17 21.875 5.8275 21.875C2.415 21.875 2.17 23.625 0 23.625V27.125C3.325 27.125 3.7975 25.375 5.8625 25.375C7.945 25.375 8.3475 27.125 11.69 27.125C15.1025 27.125 15.33 25.375 17.5 25.375C19.67 25.375 19.8975 27.125 23.31 27.125C26.6525 27.125 27.055 25.375 29.1375 25.375C31.2025 25.375 31.675 27.125 35 27.125V23.625C32.83 23.625 32.585 21.875 29.1725 21.875C25.83 21.875 25.4275 23.625 23.345 23.625C21.175 23.625 20.9125 21.875 17.5 21.875ZM32.095 13.72L29.6975 16.1175C29.365 16.4325 28.91 16.625 28.455 16.625H26.25V10.7625L28.56 12.46L30.625 9.625L17.5 0L4.375 9.625L6.44 12.4425L8.75 10.7625V16.625H6.545C6.0725 16.625 5.635 16.4325 5.3025 16.1175L2.905 13.72L0.4375 16.1875L2.835 18.585C3.815 19.565 5.1625 20.125 6.545 20.125H28.4375C29.8375 20.125 31.1675 19.565 32.1475 18.585L34.545 16.1875L32.095 13.72ZM19.25 16.625V13.125H15.75V16.625H12.25V8.19L17.5 4.34L22.75 8.19V16.625H19.25Z",
    fill: "#C0C0C0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.1f6c3dd94dcbdb96d1565e13ab41d999.svg";
export { ForwardRef as ReactComponent };